"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentRelationImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentRelation operations. */
var DocumentRelationImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentRelation class.
   * @param client Reference to the service client
   */
  function DocumentRelationImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentRelationImpl);
    this.client = client;
  }
  /**
   * Gets directly related targets documents of a specified relation type. (Auth:
   * RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param fieldSetName
   * @param relationTypeCode
   * @param sourceBookmark
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentRelationImpl, [{
    key: "getDocumentTargetRelationFieldsSets",
    value: function getDocumentTargetRelationFieldsSets(portalId, hiveId, fullName, fieldSetName, relationTypeCode, sourceBookmark, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        fieldSetName: fieldSetName,
        relationTypeCode: relationTypeCode,
        sourceBookmark: sourceBookmark,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentTargetRelationFieldsSetsOperationSpec);
    }
    /**
     * Gets directly related source documents of a specified relation type. (Auth:
     * RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param relationTypeCode
     * @param fieldSetName
     * @param targetBookmark
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSourceRelationFieldsSets",
    value: function getDocumentSourceRelationFieldsSets(portalId, hiveId, fullName, relationTypeCode, fieldSetName, targetBookmark, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        relationTypeCode: relationTypeCode,
        fieldSetName: fieldSetName,
        targetBookmark: targetBookmark,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSourceRelationFieldsSetsOperationSpec);
    }
    /**
     * <p>This is a general way to get related documents by type code, it will get all relations before and
     * after the provided document</p>
     * <p>Both indirect and direct revisions</p>
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param relationTypeCodes Comma separated string with relationTypeCodes to filter on
     * @param fieldSetName The fieldset provided will be used to resolve properties/data for each relation
     * @param direction Forward means fetching relations that document is Source. Reverse means getting
     *                  relations where document is Target.
     * @param options The options parameters.
     */

  }, {
    key: "getDirectionalDocumentRelationsByType",
    value: function getDirectionalDocumentRelationsByType(portalId, hiveId, fullName, relationTypeCodes, fieldSetName, direction, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        relationTypeCodes: relationTypeCodes,
        fieldSetName: fieldSetName,
        direction: direction,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDirectionalDocumentRelationsByTypeOperationSpec);
    }
    /**
     * New endpoint for returning relations as tree. Dead code for now until client is updated to handle
     * new tree forma (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param relationTypeCodes
     * @param fieldSetName
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentRelationTree",
    value: function getDocumentRelationTree(portalId, hiveId, fullName, relationTypeCodes, fieldSetName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        relationTypeCodes: relationTypeCodes,
        fieldSetName: fieldSetName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentRelationTreeOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param familyName
     * @param fullName (Access Controlled)
     * @param fieldSetName
     * @param relationTypeCodes
     * @param sourceBookmark
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentTargetRelationFieldsSetsByFamily",
    value: function getDocumentTargetRelationFieldsSetsByFamily(portalId, hiveId, familyName, fullName, fieldSetName, relationTypeCodes, sourceBookmark, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        familyName: familyName,
        fullName: fullName,
        fieldSetName: fieldSetName,
        relationTypeCodes: relationTypeCodes,
        sourceBookmark: sourceBookmark,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentTargetRelationFieldsSetsByFamilyOperationSpec);
    }
  }]);
  return DocumentRelationImpl;
}(); // Operation Specifications


exports.DocumentRelationImpl = DocumentRelationImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDocumentTargetRelationFieldsSetsOperationSpec = {
  path: "/api/Portals({portalId})/Document/Relations/Target/FieldSet({fieldSetName})/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelatedTargetDocumentFieldSetModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.relationTypeCode, Parameters.sourceBookmark],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentSourceRelationFieldsSetsOperationSpec = {
  path: "/api/Portals({portalId})/Document/Relations/Source/FieldSet({fieldSetName})/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelatedSourceDocumentFieldSetModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.relationTypeCode, Parameters.targetBookmark],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDirectionalDocumentRelationsByTypeOperationSpec = {
  path: "/api/Portals({portalId})/Document/Relations/Direction({direction})/FieldSet({fieldSetName})/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Dictionary",
              value: {
                type: {
                  name: "any"
                }
              }
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.relationTypeCodes],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName, Parameters.direction],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentRelationTreeOperationSpec = {
  path: "/api/Portals({portalId})/Document/Relations/Tree/FieldSet({fieldSetName})/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentRelationNodeDto
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.relationTypeCodes],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentTargetRelationFieldsSetsByFamilyOperationSpec = {
  path: "/api/Portals({portalId})/Document/Relations/Target/FieldSet({fieldSetName})/h/{hiveId}/family/{familyName}/fullname/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelatedTargetDocumentFieldSetsDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.sourceBookmark, Parameters.relationTypeCodes],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName, Parameters.familyName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};